import { find, propEq } from 'ramda';

export const findById = id => find(propEq('id', id));
export const findByName = name => find(propEq('name', name));
